import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-refer-provider',
  templateUrl: './refer-provider.component.html',
  styleUrls: ['./refer-provider.component.scss'],
})
export class ReferProviderComponent {

  constructor(public service:ApiService,public handler:HandlerService, public router:Router) { }
  items:any=[];
  loader:boolean = true;

  ionViewWillEnter() {
    this.service.getOrg().subscribe(res=>{
      this.items = res;
      this.loader = false;
    },err=>{
      this.loader = false;
      this.handler.err(err)
    })
   
  }
  share(id){
    this.router.navigate(['/shareorg',id]);
  }

}

